// extracted by mini-css-extract-plugin
module.exports = {"cardVerticalLayout":"styles_cardVerticalLayout__HIV7B","cardVerticalReverse":"styles_cardVerticalReverse__ZLF3Z","cardHorizontalLayout":"styles_cardHorizontalLayout__k0CQe"};